var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mixcloud__container"},[_c('iframe',{attrs:{"id":"mixcloud","width":"100%","height":"60","src":_vm.url + _vm.slug + '%2F',"frameborder":"0","allow":"autoplay"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }